import I18n from 'I18n';
import { createSelector } from 'reselect';
import { getDataValidationErrors } from 'ContentEditorUI/redux/selectors/moduleErrorSelectors';
// @ts-expect-error not typed
import { getErrorLabels } from 'ContentEditorUI/utils/validationUtils';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { createInstanceValueSelector } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { selectIsUngatedForLocalizationArticleTitle, selectUserHasManagePrivateContentPermission } from '../../auth/selectors/auth';
import { selectAccessRuleType, selectAccessListIds } from '../../settings/selectors/articleInstanceSelectors';
import { DEEP_LINK_QUERIES } from '../../constants';
import { selectHasArticlePublishPermission } from '../../auth/selectors/auth';
import { selectHasAudienceControlMismatch } from '../../settings/selectors/knowledgeBaseSelectors';
import { hasNoAccessGroupsSelected } from 'ui-memberships-settings-lib/utils/publicAccessRuleValidation';
import { getDefaultArticleName } from '../../articles/constants/ArticleConstants';
const extraHandlers = {
  customRequired: (error, fieldName) => ({
    message: 'knowledgeArticleEditorUI.error.customRequired',
    data: {
      niceFieldName: error.fieldSchema.title
    },
    target: fieldName,
    pane: error.pane,
    useHtml: true,
    onClickData: {
      settingsModalQuery: error.settingsModalQuery
    }
  })
};
const selectArticleTitle = createInstanceValueSelector('hs_name');
const selectArticlePath = createInstanceValueSelector('hs_path');
const selectArticleAnswer = createInstanceValueSelector('hs_body');
const selectArticleMetaDescription = createInstanceValueSelector('hs_meta_description');
const selectArticleCategory = createInstanceValueSelector('hs_knowledge_category_id');
const selectPublishValidationErrors = createSelector([selectAccessRuleType, selectAccessListIds, selectArticleTitle, selectArticleAnswer, selectArticlePath, selectArticleMetaDescription, selectArticleCategory, selectHasArticlePublishPermission, selectUserHasManagePrivateContentPermission, selectHasAudienceControlMismatch, selectIsUngatedForLocalizationArticleTitle], (selectedVisibility, selectedListIds, title, subtitle, path, metaDescription, category, hasPermissionToPublish, userHasManagePrivateContentPermission, hasAudienceControlMismatch, isUngatedForLocalizationArticleTitle) => {
  const errors = {};
  if (!title || title === getDefaultArticleName(isUngatedForLocalizationArticleTitle)) {
    errors.title = {
      pane: 'settings',
      type: 'required',
      fieldSchema: {
        title: I18n.text('knowledgeArticleEditorUI.header.publishButton.errors.title')
      },
      settingsModalQuery: DEEP_LINK_QUERIES.GENERAL.TITLE
    };
  }
  if (!subtitle) {
    errors.answer = {
      pane: 'content',
      type: 'required',
      messageKey: 'knowledgeArticleEditorUI.header.publishButton.errors.answer'
    };
  }
  if (!path || path.includes('temporary-slug')) {
    errors.slug = {
      pane: 'settings',
      type: 'required',
      fieldSchema: {
        title: I18n.text('knowledgeArticleEditorUI.header.publishButton.errors.slug')
      },
      settingsModalQuery: DEEP_LINK_QUERIES.GENERAL.SLUG
    };
  }
  if (!metaDescription) {
    errors.metaDescription = {
      pane: 'settings',
      type: 'required',
      fieldSchema: {
        title: I18n.text('knowledgeArticleEditorUI.header.publishButton.errors.metaDescription')
      },
      settingsModalQuery: DEEP_LINK_QUERIES.METADATA.META_DESCRIPTION
    };
  }
  if (!category) {
    errors.category = {
      pane: 'settings',
      type: 'required',
      fieldSchema: {
        title: I18n.text('knowledgeArticleEditorUI.header.publishButton.errors.category')
      },
      settingsModalQuery: DEEP_LINK_QUERIES.CATEGORIES.CATEGORY
    };
  }
  if (!hasPermissionToPublish) {
    errors.notAuthorized = {
      pane: 'settings',
      type: 'required',
      messageKey: 'knowledgeArticleEditorUI.header.publishButton.errors.notAuthorizedReason'
    };
  }
  if (hasAudienceControlMismatch) {
    errors.audienceAccess = {
      pane: 'settings',
      type: 'customRequired',
      fieldSchema: {
        title: I18n.text('knowledgeArticleEditorUI.header.publishButton.errors.articleAccessTypeMismatch')
      },
      settingsModalQuery: DEEP_LINK_QUERIES.ACCESS_CONTROL
    };
  }
  const userHasNotSelectedRequiredAccessGroups = hasNoAccessGroupsSelected([{
    type: selectedVisibility,
    ids: selectedListIds
  }]);
  if (userHasManagePrivateContentPermission && userHasNotSelectedRequiredAccessGroups) {
    errors.audienceAccess = {
      pane: 'settings',
      type: 'accessGroupsRequired',
      target: 'audienceAccess',
      settingsModalQuery: DEEP_LINK_QUERIES.ACCESS_CONTROL
    };
  }
  return errors;
});
const selectArticleErrorsAndWarnings = createSelector(
// @ts-expect-error TODO: Fix the auth state such that it returns all of UserInfo
[getDataValidationErrors, selectPublishValidationErrors], (moduleDataValidationErrors, publishingErrors) => {
  return {
    errors: Object.assign({}, moduleDataValidationErrors, publishingErrors),
    warnings: {
      /* ...settings warnings */
    }
  };
});
export const selectArticleErrorLabels = createSelector(selectArticleErrorsAndWarnings, ({
  errors
}) => getErrorLabels(errors, extraHandlers));
export const selectArticleWarningLabels = createSelector(selectArticleErrorsAndWarnings, ({
  warnings
}) => getErrorLabels(warnings));
export const selectBaseModalSettings = basicSelector(state => state.baseModalSettings);
export const selectScrollToElement = createSelector([selectBaseModalSettings], settings => settings.scrollToElement);